import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  onClick?: () => void;
  className?: string;
  href?: string;
  scrollToId?: string;
}
function smoothScrollTo(elementId: string) {
  const target = document.getElementById(elementId);
  if (!target) return;
  const startPosition = window.pageYOffset;
  const targetPosition = target.getBoundingClientRect().top + startPosition - 60;
  const distance = targetPosition - startPosition;
  const duration = 1200; // ms — medium speed
  let startTime: number | null = null;
  function animation(currentTime: number) {
    if (startTime === null) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    // easeInOutCubic
    const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    window.scrollTo(0, startPosition + distance * ease);
    if (elapsed < duration) requestAnimationFrame(animation);
  }
  requestAnimationFrame(animation);
}
export function CTAButton({
  text,
  subtext,
  onClick,
  className = '',
  href,
  scrollToId = 'compra'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href && scrollToId) {
      e.preventDefault();
      smoothScrollTo(scrollToId);
    }
    onClick?.();
  };
  const content = <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(220, 38, 38, 0)', '0px 0px 20px rgba(220, 38, 38, 0.5)', '0px 0px 0px rgba(220, 38, 38, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity
    }
  }} className={`w-full bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-6 rounded-lg shadow-xl border-b-4 border-red-800 flex flex-col items-center justify-center text-center uppercase tracking-wide ${className}`} onClick={handleClick} data-id="element-79">
      <span className="text-xl md:text-2xl flex items-center gap-2" data-id="element-80">
        {text} <ArrowRight className="w-6 h-6" data-id="element-81" />
      </span>
      {subtext && <span className="text-xs md:text-sm font-normal opacity-90 normal-case mt-1" data-id="element-82">
          {subtext}
        </span>}
    </motion.button>;
  if (href) {
    return <a href={href} className="w-full block no-underline" data-id="element-83">
        {content}
      </a>;
  }
  return content;
}